import { Route, BrowserRouter, Routes } from "react-router-dom";
import Login from "./pages/Login/Login";
import SignUp from "./pages/SignUp/SignUp";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Dashboard from "./pages/Dashboard/Dashboard";
import Price from "./pages/Price/Price";
import ExerciseTest from "./pages/ExerciseTest/ExerciseTest";
import SendOTP from "./pages/SendOTP/SendOTP";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import SnackBar from "./components/Snackbar/Snackbar";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import AuthRedirect from "./components/AuthRedirect";
import UserProfile from "./pages/UserProfile/UserProfile";
import DashboardWrapper from "./pages/Dashboard/DashboardWrapper";
import AdminDashboard from "./pages/Admin/LayoutAdmin/LayoutAdmin";
import LayoutAdmin from "./pages/Admin/LayoutAdmin/LayoutAdmin";
import LayoutWrapper from "./pages/Admin/LayoutAdmin/LayoutWrapper";
import EmailTemplates from "./pages/EmailTemplates/EmailTemplates";
import HelpCenter from "./pages/HelpCenter/HelpCenter";
import PaymentSuccess from "./components/PaymentDialogues/PaymentSuccess";
import PaymentFailure from "./components/PaymentDialogues/PaymentFailure";
import PaymentCancelled from "./components/PaymentDialogues/PaymentCancelled";
import TestResult from "./components/TestResult/TestResult";
import CourseList from "./components/CourseList/CourseList";
import PersonalizeLearningDialog from "./components/PersonalizeLearningDialog/PersonalizeLearningDialog";
import PaymentProcessing from "./components/PaymentDialogues/PaymentProcessing";
import EnrolledCourses from "./components/EnrolledCourses/EnrolledCourses";
import ExerciseTestCourse from "./components/EnrolledCourses/ExerciseTestCourse";
import PurchaseDetails from "./components/PurchaseDetails/PurchaseDetails";
import GeneratingCourse from "./components/GeneratingCourse/GeneratingCourse";
import AdminLogin from "./pages/Admin/AdminLogin/AdminLogin";
import AdminProtectedRoute from "./components/AdminProtectedRoute/AdminProtectedRoute";
import UserManagement from "./pages/Admin/UserManagement/UserManagement";
import PlanManagements from "./components/AdminComponents/PlanManagements/PlanManagements";
import ViewEditPlan from "./components/AdminComponents/ViewEditPlan/ViewEditPlan";
import UserDetails from "./pages/Admin/UserDetails/UserDetails";
import EnrolledCoursesIntermediate from "./components/EnrolledCourses/EnrolledCoursesIntermediate";
import EnrolledCoursesAdvanced from "./components/EnrolledCourses/EnrolledCoursesAdvanced";
import PaymentSuccessDialog from "./components/PaymentDialogues/PaymentSuccessDialog";
import GenerateTest from "./components/AdminComponents/Document/DocumentUpload";
import ViewFileUploaded from "./components/AdminComponents/Document/ViewFileUploaded";
import useGoogleTranslateDetect from "./hooks/useGoogleTranslateDetect";
import useStorageListener from "./hooks/useStorageListener";

function App() {
  useGoogleTranslateDetect();
  useStorageListener();
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AuthRedirect><SignUp /></AuthRedirect>} />
          <Route path="/login" element={<AuthRedirect><Login /></AuthRedirect>} />
          <Route path="/forgot_password" element={<AuthRedirect><ForgotPassword /></AuthRedirect>} />
          <Route path="/send_otp" element={<AuthRedirect><SendOTP /></AuthRedirect>} />
          <Route path="/reset_password" element={<AuthRedirect><ResetPassword /></AuthRedirect>} />  
          <Route path="/dashboard" element={<ProtectedRoute ><Dashboard /></ProtectedRoute>}>
            <Route index element={<DashboardWrapper />} />
            <Route path = "profile"  element = {<UserProfile /> }/>
            <Route path="plan_details" element={<PurchaseDetails/>}/>
            <Route path = "help_center"  element = {<HelpCenter /> }/>
            <Route path="test_score" element={<ProtectedRoute><TestResult/></ProtectedRoute>}/>
            <Route path="course_list" element={<CourseList></CourseList>}/>            
            <Route path="enrolled_course" element={<EnrolledCourses></EnrolledCourses>}/>
            <Route path="intermediate_course" element={<EnrolledCoursesIntermediate></EnrolledCoursesIntermediate>}/>
            <Route path="advanced_course" element={<EnrolledCoursesAdvanced></EnrolledCoursesAdvanced>}/>
          </Route>

          <Route path="/price/:location?" element={<ProtectedRoute><Price /></ProtectedRoute> } />
          <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccessDialog /></ProtectedRoute> } />
          <Route path="/test" element={<ProtectedRoute><ExerciseTest /></ProtectedRoute>} />
          <Route path="/course_test" element={<ProtectedRoute><ExerciseTestCourse /></ProtectedRoute>} />
          {/* Admin Dashboard  */}
          <Route path="/admin_login" element={<AuthRedirect><AdminLogin/></AuthRedirect>}></Route>
          <Route path="/admin" element={<AdminProtectedRoute><LayoutAdmin/></AdminProtectedRoute>}>
            <Route index element={<LayoutWrapper/>} />
            <Route path="user_management" element={<UserManagement/>}/>
            <Route path="plan_management" element={<PlanManagements/>}/>
            <Route path="view_user_details" element={<UserDetails/>}/>
            <Route path="create_plan" element={<ViewEditPlan/>}/>
            <Route path="knowledge_base" element={<GenerateTest/>}/>
            <Route path="view_file_uploaded/:upload_id" element={<ViewFileUploaded/>}/>
          </Route>
          <Route path="/email" element={<EmailTemplates/>}></Route>
          <Route path="/paypal/return" element={<PaymentProcessing />} />
          <Route path="/payment/failure" element={<PaymentFailure />} />
          <Route path="/paypal/cancel" element={<PaymentCancelled />} />
          <Route path="/purchase-details" element={<PurchaseDetails />} />
          <Route path="/generating" element={<GeneratingCourse />} />
        </Routes>
      </BrowserRouter>
      <SnackBar />
    </>
  );
}

export default App;
